import { Routes } from '@angular/router';

export const deviceDataloggerRouter: Routes = [
  {
    path: 'hardware',
    loadComponent: () =>
      import('./hardware/components/dt-hardware/dt-hardware.component').then(
        (m) => m.DtHardwareComponent,
      ),
  },
  {
    path: 'rs485-masters',
    loadComponent: () =>
      import(
        './rs485-master/components/dt-rs485-master/dt-rs485-master.component'
      ).then((m) => m.DtRs485MasterComponent),
  },
  {
    path: 'rejected-uplinks',
    loadComponent: () =>
      import(
        './rejected-uplinks/components/dt-rejected-uplinks/dt-rejected-uplinks.component'
      ).then((m) => m.DtRejectedUplinksComponent),
  },
  {
    path: '',
    loadComponent: () =>
      import('./components/dt-datalogger/dt-datalogger.component').then(
        (m) => m.DtDataloggerComponent,
      ),
  },
];
